// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type FindItemJsonRequest from '../contract/FindItemJsonRequest';

export default function findItemJsonRequest(data: FindItemJsonRequest): FindItemJsonRequest {
    const result: FindItemJsonRequest = {
        __type: 'FindItemJsonRequest:#Exchange',
        ...data,
    };

    return result;
}
